module.exports = __webpack_public_path__ + "static/tm2-939179dbb009f56d628cbc64b04ff115.png";